import { render, staticRenderFns } from "./PageViewUserDetails.vue?vue&type=template&id=68934bcf&"
import script from "./PageViewUserDetails.vue?vue&type=script&lang=js&"
export * from "./PageViewUserDetails.vue?vue&type=script&lang=js&"
import style0 from "./PageViewUserDetails.vue?vue&type=style&index=0&id=68934bcf&prod&lang=scss&"
import style1 from "./PageViewUserDetails.vue?vue&type=style&index=1&id=68934bcf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports